import {
    Header,
    HeaderBrand,
    HeaderNavigation,
    HeaderSubNavigation,
    HeaderUserWidget,
    HeaderWidgets,
    NavItem,
} from '@flixbus/honeycomb-react';

import { NavLink } from 'react-router-dom';
import React from 'react';
import styles from './rh-header.module.scss';

/* eslint-disable-next-line */
export interface RhHeaderProps {
    displayName?: string;
    versionTag: string;
    countrySelect: React.ReactNode;
    environment?: 'stg' | 'prod' | 'local';
}

export function RhHeader(props: RhHeaderProps) {
    const isDevEnvironment = props.environment !== 'prod';

    return (
        <Header
            fullwidth
            brand={
                <div className={styles.brandContainer}>
                    <HeaderBrand
                        extraClasses={styles.headerLogo}
                        alt={isDevEnvironment ? 'RideHub Dev' : 'RideHub'}
                        href="/rides"
                        RouterLink={NavLink}
                        src="/ridehub_logo.svg"
                        appearance="tall"
                        data-dd-action-name="Go to Search by Id"
                    />
                    {isDevEnvironment && <span className={styles.devBadge}>Dev</span>}
                </div>
            }
            navigation={
                props.displayName ? (
                    <HeaderNavigation aria-label="Main">
                        <NavItem RouterLink={NavLink} to="/enter-id" data-dd-action-name="Go to Search by Id">
                            Enter ID
                        </NavItem>
                        <NavItem RouterLink={NavLink} to="/rides" data-dd-action-name="Go to Rides">
                            Rides
                        </NavItem>
                    </HeaderNavigation>
                ) : (
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (null as any)
                )
            }
            widgets={
                <HeaderWidgets>
                    <div className={styles.headerWidgets}>
                        {props.countrySelect}
                        {!!props.displayName && (
                            <HeaderUserWidget
                                data-dd-privacy="mask"
                                data-dd-action-name="Open Profile Menu"
                                subMenu={
                                    <HeaderSubNavigation alignment="left" id="user-sub-menu" data-dd-privacy="allow">
                                        <NavItem href="/logout">Logout</NavItem>
                                        <NavItem>Version: {props.versionTag}</NavItem>
                                    </HeaderSubNavigation>
                                }
                            >
                                {props.displayName}
                            </HeaderUserWidget>
                        )}
                    </div>
                </HeaderWidgets>
            }
        />
    );
}

export default RhHeader;
